import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSelector.vue?vue&type=style&index=0&id=6861f0ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6861f0ba"]])

export default __exports__